(function ($) {
    $(document).ready(function () {
        extraServices();
    });

    function extraServices() {
        var wrap = $('.section.services_grid .list');

        if (wrap.length > 0) {
            wrap.each( function () {
                var single_wrap = $(this);
                single_wrap.on("init", function () {
                    lazyLoadInstance.update();
                });
                single_wrap.slick({
                    autoplay: false,
                    arrows: true,
                    dots: true,
                    infinite: true,
                    prevArrow: accor_arrow_prev,
                    nextArrow: accor_arrow_next,
                    appendDots: wrap.closest('.section').find('.pager'),
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    centerMode: true,
                    adaptiveHeight: false,
                    centerPadding: '550px',
                    rtl: $('html').attr('dir') === 'rtl',
                    responsive :[
                        {
                            breakpoint: 767,
                            settings: {
                                dots:false,
                                variableWidth: false,
                                centerPadding: '20px'
                            }
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                variableWidth: true,
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                centerPadding: '20px',
                            }
                        },
                        {
                            breakpoint: 1420,
                            settings: {
                                variableWidth: true,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                centerPadding: '60px',
                            }
                        },
                    ]
                });
            })
        }
    }

})(jQuery);